exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inp-table[data-v-037dc52c]{width:100%}.inp-table .cln-numero[data-v-037dc52c]{width:50px;min-width:50px}.inp-table .cln-type[data-v-037dc52c]{width:150px;min-width:150px}.inp-table .cln-titre[data-v-037dc52c]{width:calc(100% - 306px);min-width:calc(100% - 306px)}.inp-table .cln-action[data-v-037dc52c]{width:106px;min-width:106px}.inp-table .line[data-v-037dc52c]{background-image:url(" + require("../../../assets/bg_tableau.png") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-037dc52c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/ficheSociete/reglements/reglementsSociete.scss
// module id = aMS+
// module chunks = 2